<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input type="text" placeholder="input" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="">
                  <input type="text" placeholder="input" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo hủy hóa đơn` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>- Recode: Hiển thị mã đặt phòng</li>
            <li>- Số hóa đơn: hiển thị số hóa đơn bị hủy</li>
            <li>- Thành tiền: Hiển thị số tiền của hóa đơn bị hủy</li>
            <li>
              - Lý do hủy: Khi hủy hóa đơn => hiển thị Pop up nhập lý do hủy hóa
              đơn: hiển thị lý do hủy
            </li>
            <li>
              - Thời gian: Hiển thị thời gian hủy hóa đơn: theo format DDMMYYYY
              HHMMSS
            </li>
            <li>
              - Người thao tác: hiển thị Họ và tên nhân viên thao tác hủy hóa
              đơn
            </li>
            <li>***Lưu ý:</li>
            <li>
              - với cột có giá trị là tiền tự động hiển thị dấu phẩy ngăn cách.
              Ví dụ: 100000 (1 triệu) hiển thị 1,000,000
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'

export default {
  components: { DownloadBtn, NoteDialog },
  data() {
    return {
      // grid
      columns: [
        {
          headerName: 'Recode',
          field: ''
        },
        {
          headerName: 'Số hóa đơn',
          field: ''
        },
        {
          headerName: 'Thành tiền',
          field: ''
        },
        {
          headerName: 'Lý do hủy',
          field: ''
        },
        {
          headerName: 'Thời gian',
          field: ''
        },
        {
          headerName: 'Người thao tác',
          field: ''
        }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
